<a
  class="flex items-center justify-center h-full bg-gray-100 relative"
  [routerLink]="articleBlockComponent?.isPremium !== true ? link : undefined"
  role="link"
>
  <tisa-image
    role="img"
    [attr.aria-label]="articleBlockComponent?.article?.title"
    [src]="image"
    [alt]="'image'"
    [height]="maxImageHeight"
    [style.maxHeight]="maxImageHeight"
    class="transform hover:scale-110 duration-100"
  ></tisa-image>
  <tisa-premium-overlay *ngIf="isPremium"></tisa-premium-overlay>
</a>
